import Partner from '../models/partner'
import sessionHelper from '../sessionHelper'

export default {
  namespaced: true,
  state: {
    account: new Partner(global.dataInit.partnerAccount, sessionHelper.getJsonItem('currentCamping'))
  },
  getters: {
    // camping sélectionné
    currentCampingId: state => {
      return state.account.currentCamping !== null ? state.account.currentCamping.id : null
    }
  },
  mutations: {
    // affecte le camping sélectionné par un groupe
    selectCampsite (state, data) {
      state.account.currentCamping = data
      sessionHelper.setJsonItem('currentCamping', data)
    },
    // supprime le stockage du camping dans la session
    delete (state, data) {
      sessionHelper.removeItem('currentCamping')
    }
  }
}
